const en = {
  siteName: "Emel Yıldırım",
  siteTagline: "Software Engineer",

  navHome: "Home",
  navBlog: "Writing",
  navProjects: "Projects",
  navResume: "Resume",
  navAbout: "About",
  navContact: "Contact",

  heroTitle: "I build software for enterprise systems.",
  heroLead:
    "Focused on Oracle PL/SQL, database-driven applications, and process-oriented modules (CRM/Helpdesk) — with sustainable and measurable outcomes.",
  heroCtaPrimary: "Read posts",
  heroCtaResume: "View resume",
  heroCtaSecondary: "Get in touch",

  profileTitle: "Oracle PL/SQL & Enterprise Apps",
  hlPlsql: "Oracle PL/SQL (19c) package/procedure development",
  hlEnterprise: "End-to-end delivery: analysis → build → maintenance",
  hlCrm: "CRM, Helpdesk and process management modules",
  hlData: "Data modeling and business rules integration",
  hlWeb: "REST APIs and web UI (React / basic Next.js)",
  hlDocs: "Technical documentation and user training",

  focusDbTitle: "Database & PL/SQL",
  focusDbDesc:
    "PL/SQL solutions balancing performance, integrity, and maintainability.",
  focusEnterpriseTitle: "Processes & Modules",
  focusEnterpriseDesc:
    "Operational systems where UI + rules + reporting must work together.",
  focusWebTitle: "Web & Integration",
  focusWebDesc: "RESTful services, dashboards, and user-first interfaces.",

  sectionFocus: "Focus areas",
  sectionLatestPosts: "Featured writing",
  sectionProjects: "Selected work",
  sectionApproach: "How I work",
  sectionApproachLead:
    "Need → process → technical decisions → measurable outcomes.",
  finalCtaTitle: "Want to work together?",
  finalCtaLead:
    "For a role, project, or consulting — feel free to reach out. You can also review my resume and selected work.",

  trustBand: [
    { k: "Oracle & SQL", v: "Database-driven enterprise solutions" },
    { k: "Processes", v: "CRM/Helpdesk & operational modules" },
    { k: "Reporting", v: "Dashboards, KPIs, visibility" },
    { k: "End-to-end", v: "Analysis → build → maintenance" },
  ],

  approachSteps: [
    { title: "Clarify the need", desc: "Understand the problem and users." },
    { title: "Model & simplify", desc: "Find bottlenecks and define flow." },
    {
      title: "Design the technical core",
      desc: "Data model, rules, performance.",
    },
    { title: "Build usable UI", desc: "Interfaces that truly support work." },
    {
      title: "Iterate & improve",
      desc: "Maintenance, reporting, documentation.",
    },
  ],

  blogTitle: "Writing",
  readMore: "Read more",
  backToPosts: "Back to all posts",
  minutes: "min",
  filterAll: "All",
  viewDetails: "View details",
  backToProjects: "Projects",
  projectSummary: "Summary",
  projectProblem: "Problem",
  projectRole: "My role",
  projectDecisions: "Key decisions",
  projectOutcome: "Outcome",
  projectLearnings: "Learnings",

  aboutTitle: "About",
  aboutText:
    "I’m a software engineer with experience in enterprise software projects. I care about end-to-end ownership, database-first thinking, and improving business processes with reliable, maintainable solutions.",

  contactTitle: "Contact",
  contactLead:
    "For collaboration, consulting, or questions — you can reach me via email.",
  contactEmailLabel: "Email",
  contactLinksLabel: "Links",
  contactAction: "Send email",
  contactNote:
    "Note: The form uses EmailJS. Keys are stored in `.env.local` so nothing sensitive is committed.",
  contactFormTitle: "Contact form",
  contactFormEnvHint:
    "EmailJS keys are missing. Create a `.env.local` file to enable the form.",
  formName: "Full name",
  formNamePh: "Your name",
  formEmail: "Email",
  formEmailPh: "name@company.com",
  formMessage: "Message",
  formMessagePh: "Tell me briefly what you need…",
  formSend: "Send",
  formSending: "Sending…",
  formSuccess: "Message sent.",
  formError: "Failed to send. Please try again.",

  footerNote: "Notes on enterprise systems, databases, and web engineering.",
  year: "2026",

  resumeTitle: "Resume",
  resumeDownload: "Download PDF",
  resumePresent: "Present",
  resumeSummaryTitle: "Summary",
  resumeExperienceTitle: "Experience",
  resumeSkillsTitle: "Skills",
  resumeEducationTitle: "Education",
  resumeLanguagesTitle: "Languages",
};
export default en;
